export const workoutList = [
  {
    title: "Warm Up",
    url: "warm-up",
    thumbnail:
      "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/program-thumbnails/text-warm-up.png",
  },
  {
    title: "False Grip",
    url: "false-grip",
    thumbnail:
      "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/program-thumbnails/text-false-grip.png",
  },
  {
    title: "Transition",
    url: "transition",
    thumbnail:
      "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/program-thumbnails/text-transition.png",
  },
  {
    title: "Strenght",
    url: "strenght",
    thumbnail:
      "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/program-thumbnails/text-strength.png",
  },
  {
    title: "Shoulder Conditioning",
    url: "shoulder-conditioning",
    thumbnail:
      "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/program-thumbnails/shoulder-opeing-cool-down-05.png",
  },
];

export const programDataMuscleUp = {
  workouts: [
    {
      url: "head-neck",
      title: "Head & Neck",
      thumbnail:
        "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/wrists-thumbnail.png",
      exercises: [
        {
          url: "head",
          title: "Head & Neck Mobilisation 1A",
          sets: "1",
          reps: "10",
          rest: false,
          description: (
            <div>
              <ul>
                <li>{" Palms forwards x 10"}</li>
                <li>{" Palms backwards x 10"}</li>
              </ul>
            </div>
          ),
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/thumb.jpg",
              title: "Head & Neck Mobilisation",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/4100534b-3a6b-4433-9b58-0581fed0db4a.gif?ClientID=sulu&Date=1724942739&Signature=c4ff3c1841fc6367e76087e0ecb3ee3537fef74f",
              title: "Head & Neck Mobilisation",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004100926?h=092feab0f3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Head & neck mobilisation 1a",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-front-side-view.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-back.gif",
            },
          ],
        },

        {
          url: "head",
          title: "Head & Neck Mobilisation 1B",
          sets: "1",
          reps: "10",
          rest: false,
          description: (
            <div>
              <ul>
                <li>{" Palms forwards x 10"}</li>
                <li>{" Palms backwards x 10"}</li>
              </ul>
            </div>
          ),
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/head-neck-mbilization-1b.jpg",
              title: "Head & Neck Mobilisation 1B",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/c338c9da-bf6e-45ec-9510-fd0ad2270166.gif?ClientID=sulu&Date=1724943009&Signature=30eb18f435656ebfbfe2892b67cce60fb05960c5",
              title: "Head & Neck Mobilisation 1B",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/918925826?h=becc23fbae&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Head & neck mobilisation 1B",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-front-side-view.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-back.gif",
            },
          ],
        },
        {
          url: "head",
          title: "Head & Neck Mobilisation 2A",
          sets: "1",
          reps: "10",
          rest: false,
          description: (
            <div>
              <ul>
                <li>{" Palms forwards x 10"}</li>
                <li>{" Palms backwards x 10"}</li>
              </ul>
            </div>
          ),
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+and+neck+mobilisation+2a-down.jpg",
              title: "Head & Neck Mobilisation 2A - Down",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+and+neck+mobilisation+2a-up.jpg",
              title: "Head & Neck Mobilisation 2A - Up",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/5a58b769-4a27-412f-822f-963d0e940f27.gif?ClientID=sulu&Date=1724943685&Signature=72f80d64380965d3e3256b3fc918ba9a6cf638ca",
              title: "Head & Neck Mobilisation 2A",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004104638?h=ebc5dccb47&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Head & neck mobilisation 2A",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-front-side-view.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-back.gif",
            },
          ],
        },
        {
          url: "head",
          title: "Head & Neck Mobilisation 2B",
          sets: "1",
          reps: "10",
          rest: false,
          description: (
            <div>
              <ul>
                <li>{" Palms forwards x 10"}</li>
                <li>{" Palms backwards x 10"}</li>
              </ul>
            </div>
          ),
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+and+neck+mobilisation+2a-down.jpg",
              title: "Head & Neck Mobilisation 2A - Down",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+and+neck+mobilisation+2a-up.jpg",
              title: "Head & Neck Mobilisation 2A - Up",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/5a58b769-4a27-412f-822f-963d0e940f27.gif?ClientID=sulu&Date=1724943685&Signature=72f80d64380965d3e3256b3fc918ba9a6cf638ca",
              title: "Head & Neck Mobilisation 2A",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004104638?h=ebc5dccb47&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Head & neck mobilisation 2A",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-front-side-view.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-back.gif",
            },
          ],
        },
        {
          url: "head",
          title: "Head & Neck Mobilisation 3A",
          sets: "1",
          reps: "10",
          rest: false,
          description: (
            <div>
              <ul>
                <li>{" Palms forwards x 10"}</li>
                <li>{" Palms backwards x 10"}</li>
              </ul>
            </div>
          ),
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+%26+neck+mobilisation+3a-right.jpg",
              title: "Head & neck mobilisation 3a-right",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+%26+neck+mobilisation+3a-left.jpg",
              title: "Head & neck mobilisation 3a-left",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/8a5db8da-389f-4f11-bfd6-14640298abb9.gif?ClientID=sulu&Date=1724944205&Signature=1299459afd8f85848228b776d7be5cab3635b064",
              title: "Head & Neck Mobilisation 3A",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004105763?h=18511b67e7&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Head & neck mobilisation 3A",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-front-side-view.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-back.gif",
            },
          ],
        },
        {
          url: "head",
          title: "Head & Neck Mobilisation 3B",
          sets: "1",
          reps: "10",
          rest: false,
          description: (
            <div>
              <ul>
                <li>{" Palms forwards x 10"}</li>
                <li>{" Palms backwards x 10"}</li>
              </ul>
            </div>
          ),
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+and+neck+mobilisation+3b-right.jpg",
              title: "Head & neck mobilisation 3B-right",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+and+neck+mobilisation+3b-left.jpg",
              title: "Head & neck mobilisation 3B-left",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/ad57dfea-a583-4d32-a0a4-2451bc20bca7.gif?ClientID=sulu&Date=1724944798&Signature=c5d798a26d222de8f0745c892e23c850d2e32891",
              title: "Head & Neck Mobilisation 3B",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004106433?h=b46129cd9a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Head & neck mobilisation 3B",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-front-side-view.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-back.gif",
            },
          ],
        },
        {
          url: "head",
          title: "Mobilisation 4 - Retraction",
          sets: "1",
          reps: "10",
          rest: false,
          description: (
            <div>
              <ul>
                <li>{" Palms forwards x 10"}</li>
                <li>{" Palms backwards x 10"}</li>
              </ul>
            </div>
          ),
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/head/Head+and+neck+mobilisation+4+-+retraction.jpg",
              title: "Head and neck mobilisation 4 - Retraction",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/96a1f8f1-354c-4ec0-af97-fea644ab30f6.gif?ClientID=sulu&Date=1724945509&Signature=0d04113e47efbdf4f49a43b7243fd529c8ea2118",
              title: "Head and neck mobilisation 4 - Retraction",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004108735?h=458b21e1c5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Head and neck mobilisation 4 - Retraction",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-front-side-view.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/wrists/palms-back.gif",
            },
          ],
        },
      ],
    },
    {
      url: "wrists",
      title: "Wrists",
      thumbnail:
        "https://app-fitness.s3.eu-west-2.amazonaws.com/german-hang/german-hang-low-res.jpg",
      exercises: [
        {
          url: "wrists-onto-finger-tips",
          title: "Onto Finger Tips",
          sets: "1",
          reps: "8-10",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/low-res-wrisit-onto-finger-tips.jpg",
              title: "Side View - Onto Finger Tips",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/low-res-wrist-front-view-onto-finger-tips.jpg",
              title: "Front View - Onto Finger Tips",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/b27cca11-3ba9-469e-9014-f4485686e93a.gif?ClientID=sulu&Date=1709649461&Signature=a4c710db0cbcf538f59d24d742249ec2d329d444",
              title: "Side View Gif",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e7c38168-a3a6-4962-9a37-64fff46f009d.gif?ClientID=sulu&Date=1709650139&Signature=d3c1e573cf71f67150a4532ae76cdda23d0a7b64",
              title: "Front View Gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/919628075?h=e139176ff2&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Onto Finger Tips",
              buttonTitle: "",
            },
          ],
        },
        {
          url: "wrist-rotation-walks",
          title: "Wrist Rotation Walks",
          sets: "1",
          reps: "8-10",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/Wrist+rotation+walks.jpg",
              title: "Wrist Rotation Walks",
            },

            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/cbf1061e-fd6d-400d-a79a-51214b4e9faf.gif?ClientID=sulu&Date=1724946810&Signature=76710d2dbd612d12a533c6cb0a411c09330f3f5a",
              title: "Wrist Rotation Walks Gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004111075?h=e158736856&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Wrist Rotation Walks",
              buttonTitle: "",
            },
          ],
        },
        {
          url: "wrist-and-forearm-1a",
          title: "Wrist & forearm 1a",
          sets: "1",
          reps: "8-10 - Pre Training",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/Wrist+%26+forearm+1a.jpg",
              title: "Wrist & forearm 1a",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/56791445-cb3a-4122-b8b6-43627e96e543.gif?ClientID=sulu&Date=1724947116&Signature=0de06c2600cb8f0390c0ee81c298c4ce4b221874",
              title: "Wrist & forearm 1a",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004113798?h=fa7cb097ad&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Wrist & forearm 1a",
              buttonTitle: "",
            },
          ],
        },
        {
          url: "Wrist-and-forearm-progression-1b-1c",
          title: "Progression 1b & 1c",
          sets: "1",
          reps: "30-60sec - Post Training",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/Wrist+and+forearm+progression+1b+%26+1c+Plank.jpg",
              title: "Wrist and forearm progression 1b & 1c Plank",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/Wrist+and+forearm+progression+1b+%26+1c+Plank+-+Push+up.jpg",
              title: "Plank and push up",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/2cb111bb-f684-4f41-ab16-29382d4653c3.gif?ClientID=sulu&Date=1724947977&Signature=afe472bbacb8e5b779b5eefd515f966657bac6f8",
              title: "Plank Gif",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/503c3fc1-7b23-452b-8dfb-b5ef884b6947.gif?ClientID=sulu&Date=1724948034&Signature=9eeec71f1c532dc99e62822bcc75aa0d6e2a3229",
              title: "Plank & Push Up Gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004114961?h=380b63c891&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Wrist-and-forearm-progression-1b-1c",
              buttonTitle: "",
            },
          ],
        },

        {
          url: "wrist-and-forearm-2a",
          title: "Wrist and Forearm 2a",
          sets: "1",
          reps: "30-60sec - Post Training",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/Wrist+and+forearm+2a.jpg",
              title: "Wrist and Forearm",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/7eeafecf-dc5c-4b28-9513-e97ef2e70197.gif?ClientID=sulu&Date=1724948312&Signature=5a728a95b72a8b6b6c5d53dafaa59fa40ca1bf01",
              title: "Wrist and Forearm side gif",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/97286de9-e2dc-4ef7-a4e2-e6750416f7a9.gif?ClientID=sulu&Date=1724948327&Signature=1404db8350a49b4093a78056eb6fdcaa43378966",
              title: "Wrist and Forearm front gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/918924512?h=5e1a224f11&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Wrist and Forearm 2a",
              buttonTitle: "",
            },
          ],
        },
        {
          url: "wrist-and-forearm-progression-2b-c",
          title: "Progression 2b&c",
          sets: "1",
          reps: "30-60sec - Post Training",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/Wrist+and+forearm+progression+2b%26c.jpg",
              title: "reverse wrist plank hold",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/239dcc1e-60f3-4ce6-99ce-11b95aad15b5.gif?ClientID=sulu&Date=1724948786&Signature=1560999367e78d4eb09159c86dcab1c7a1502701",
              title: "reverse wrist plank hold gif",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/fa0eceff-3bbc-4669-99f1-66646692d764.gif?ClientID=sulu&Date=1724948757&Signature=252cee0db6bb293775015c36fb4bd97091c55c52",
              title: "reverse wrist plank and push gid",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/918924940?h=291e73a0ab&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Wrist and forearm progression 2b&c",
              buttonTitle: "",
            },
          ],
        },
        {
          url: "hand-clasped-wrist-mobilisation",
          title: "Hand clasped wrist mobilisation",
          sets: "1",
          reps: "30-60sec - Post Training",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/wrists/Hand+clasped+wrist+mobilisation.jpg",
              title: "hand clasp",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/5403f737-820f-4b1d-bb32-ac3fa70772fb.gif?ClientID=sulu&Date=1724949059&Signature=a5a45dca6e23ea74ced39045d597eaf1344d43f6",
              title: "hand clasp gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004132539?h=472479dda2&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Hand clasped wrist mobilisation",
              buttonTitle: "",
            },
          ],
        },
      ],
    },
    {
      url: "shoulder-mobility",
      title: "Shoulder Mobility",
      thumbnail:
        "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/band-bar-thumbnail-low-res.jpg",
      exercises: [
        {
          url: "band-over-head-reach",
          title: "Over Head Reach",
          sets: "1",
          reps: "10",
          rest: false,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/bands/thumbnail-over-head-reach.png",
              title: "Over Head Reach",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/5eb5a724-e10f-4ad6-839b-888951d5a48e.gif?ClientID=sulu&Date=1708943669&Signature=96f9ac646d4b1882da9eea0578eaccd3ba23f622",
              title: "sample-image",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/912212101?h=d34246c5d3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Over Head Reach",
              buttonTitle: "",
            },
          ],
          description: "",
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/forward-circles.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/forward-circles-behind-view.gif",
            },
          ],
        },
        {
          url: "dislocations",
          title: "Dislocations",
          sets: "1",
          reps: "10",
          rest: false,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/bands/Dislocations.jpg",
              title: "dislocations",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/c795df0f-f7b8-4a38-a634-1a3a7df4c07e.gif?ClientID=sulu&Date=1724949538&Signature=99f428190bdef47bcea2dc5c9ad26d611a969f11",
              title: "dislocations gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004145163?h=d8523e9416&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Banded Dislocations",
              buttonTitle: "",
            },
          ],
          description: "",
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/backward-circles.gif",
            },
          ],
        },
        {
          url: "external-rotation",
          title: "External Rotation",
          sets: "1",
          reps: "10",
          rest: false,
          description: "",
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/bands/Banded+external+rotation.jpg",
              title: "external-rotation",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/eeec2ff9-4393-415d-a1d3-c6cb720fde92.gif?ClientID=sulu&Date=1724949702&Signature=bc53c684d9aa98b34873e5049e4416e59c57a40a",
              title: "external-rotation-gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004146778?h=debb662596&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Banded External rotation",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/cross-body.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/cross-body-forward-roll.gif",
            },
          ],
        },
        {
          url: "internal-rotation-band",
          title: "Internal Rotation",
          sets: "1",
          reps: "10",
          rest: false,
          description: "",
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/bands/internal-rotation-band.png",
              title: "sample-image",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/770f91dd-8065-43b0-b612-3f548449c34b.gif?ClientID=sulu&Date=1708944345&Signature=bfe0a8af613e3ea06855cdce7e2f97524957598d",
              title: "sample-image",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004155346?h=1251434262&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Internal Rotation",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/back-circles-backward-roll.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/back-circles-forward-roll.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/back-circles-backward-roll-back-view.gif",
            },
          ],
        },
        {
          url: "cuban-rotations",
          title: "Cuban Rotations",
          sets: "1",
          reps: "10",
          rest: false,
          description: "",
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/bands/Cuban+Rotation.jpg",
              title: "sample-image",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/2a858de8-5e13-4ce6-b14d-4ff9cbc44d8b.gif?ClientID=sulu&Date=1724950148&Signature=d1dfea3eac747e74e5f781983222a2fdb8d9350c",
              title: "Cuban Rotations",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1002412354?h=88a7ca93c0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Cuban Rotations",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/back-circles-backward-roll.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/back-circles-forward-roll.gif",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/warm-up-band-bar/back-circles-backward-roll-back-view.gif",
            },
          ],
        },
      ],
    },
    {
      url: "scapula-core",
      title: "Scapula & Core",
      thumbnail:
        "https://app-fitness.s3.eu-west-2.amazonaws.com/floor-wall/wall-floor-thumbnail-low-res.jpg",
      exercises: [
        {
          url: "scapula-push-up",
          title: "Scapula Push Up - REDO",
          sets: "3",
          reps: "10",
          rest: false,
          description: (
            <div>
              <ul>
                <li>{"Crunch your body up into a ball"}</li>
                <li>{"Look towards your knees"}</li>
                <li>{"Protacting your sholder blades"}</li>
                <br></br>
                <li>{"Exhale, retract and look towards the ceiling"}</li>
                <br></br>
                <li>{"Get a deeper stretch with every rep"}</li>
              </ul>
            </div>
          ),
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/scapula-core/scapula-push.png",
              title: "up",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/85018c7d-1538-497f-a907-09dbb616dab8.gif?ClientID=sulu&Date=1709454745&Signature=d2b75f1b0fa8f17854516fd7dcd0879d0b3f7f44",
              title: "down",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/912214015?h=dd600a2302&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Scapula Push Up",
              buttonTitle: "",
            },
          ],
        },
        {
          url: "hollow-body-hold",
          title: "Hollow Body Hold",
          sets: "3",
          reps: "30 seconds",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/scapula-core/Hollow+body+hold+progression+1.jpg",
              title: "progression 1",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/scapula-core/Hollow+body+hold+progression+2.jpg",
              title: "progression 2",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/scapula-core/Hollow+body+hold+progression+3.jpg",
              title: "progression 3",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/65ddad6a-5195-4ed4-b9c1-798d6ab8d721.gif?ClientID=sulu&Date=1724950823&Signature=c43620b9d19d866a459117d97a4ce39e54d0f49f",
              title: "progression 1 gif",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/4e0a76fe-23e2-4339-bdfc-4be19087b6f0.gif?ClientID=sulu&Date=1724950836&Signature=ff504571fe22c5a60aeae848287a8cb09d0792c6",
              title: "progression 2 gif",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/ec28e6ea-2f9a-4ce3-ad4e-18e461167942.gif?ClientID=sulu&Date=1724950846&Signature=591687676b0529987955306964f315deda3de1e6",
              title: "progression 3 gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004157243?h=b586ed87c9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Hollow Body Hold",
              buttonTitle: "",
            },
          ],
        },
        {
          url: "retracted-scapular-pulls",
          title: "Retracted Scapular Pulls",
          sets: "3",
          reps: "5",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/scapula-core/Retracted+scapular+pulls.jpg",
              title: "retracted Scapular pulls",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/beafa258-890f-42d3-8cae-2c9e25010cc4.gif?ClientID=sulu&Date=1724951558&Signature=c273067614a1f4392c394f2d146a238b14b6f8af",
              title: "retracted Scapular pulls gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004164082?h=7b8907d2d3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "retracted Scapular pulls",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/floor-wall/hollow-hold.gif",
            },
          ],
        },
        {
          url: "superman-progression-1-and-2",
          title: "Superman progression 1 & 2",
          sets: "3",
          reps: "10",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/scapula-core/Superman+progression+1.jpg",
              title: "progression 1",
            },
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/scapula-core/Superman+progression+2.jpg",
              title: "progression 2",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/94c094fe-ae99-49c9-9e93-597296b3ebcb.gif?ClientID=sulu&Date=1724951269&Signature=0502880c643bc775d7402da5cf75af33b7165853",
              title: "progression 1 gif",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/4c714864-29ba-499d-ac1b-5f1268414dbe.gif?ClientID=sulu&Date=1724951204&Signature=ff60a1dff584727213ec34a03360a4e64158380d",
              title: "progression 2 gif",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004161641?h=6f805f0594&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Superman progression 1 & 2",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/floor-wall/shoulder-flexions.gif",
            },
          ],
        },
        {
          url: "hanging-shrugs",
          title: "Hanging Shrugs",
          sets: "3",
          reps: "5",
          rest: false,
          description: <div></div>,
          images: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/warm-up/scapula-core/Hanging+shrugs.jpg",
              title: "Hanging Shrugs",
            },
            {
              url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/743bae4e-d5d8-4245-b454-bfd56ada056c.gif?ClientID=sulu&Date=1724951900&Signature=df3b0cd0450af9c36a664017d3d082dee5f56405",
              title: "Hanging Shrug gifs",
            },
          ],
          videoUrl: [
            {
              url: "https://player.vimeo.com/video/1004163029?h=406129bfb3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
              title: "Hanging Shrugs",
              buttonTitle: "",
            },
          ],
          thumbnailGif: [
            {
              url: "https://app-fitness.s3.eu-west-2.amazonaws.com/floor-wall/hollow-hold.gif",
            },
          ],
        },
      ],
    },
  ],
};

export const falseGripData = {
  exercises: [
    // {
    //   url: "false-grip-intro",
    //   title: "False Grip Intro",
    //   sets: "",
    //   reps: "",
    //   rest: false,
    //   description: <div></div>,
    //   images: [
    //     {
    //       url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/false-grip/false-grip-1.png",
    //       title: "false-grip-1",
    //     },
    //     {
    //       url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/false-grip/false-grip-2.png",
    //       title: "false-grip-2",
    //     },
    //     {
    //       url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/045f121a-83b9-4b5b-b331-0bc90d81d60f.gif?ClientID=sulu&Date=1708985321&Signature=625fe7b050e456b2d2b0256d42a87f5f10b41fab",
    //       title: "false-grip-3-gif",
    //     },
    //   ],
    //   videoUrl: [
    //     {
    //       url: "https://player.vimeo.com/video/912215493?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
    //       title: "False Grip Intro",
    //       buttonTitle: "",
    //     },
    //   ],
    // },
    {
      url: "false-grip-close-up",
      title: "False Grip Close Up",
      sets: "3",
      reps: "30 seconds",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/false-grip/false-grip-back.jpg",
          title: "flase grip back",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/false-grip/false-grip-front.jpg",
          title: "flase grip front",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/e5389335-78bf-4c21-b8e8-56653f9e3251.gif?ClientID=sulu&Date=1724952794&Signature=954cfea8b24823fdf2bb5a41c6ecc17172709f8e",
          title: "flase grip gif",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004169264?h=945c00c1e3&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "False Grip Close Up",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "false-grip-hang",
      title: "False Grip Hang",
      sets: "3",
      reps: "30 seconds",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/false-grip/false-grip-hang.jpg",
          title: "False Grip Hang",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004171751?h=d6ab0f2dea&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "False Grip Hang",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "false-grip-row",
      title: "False Grip Row",
      sets: "3",
      reps: "5-8",
      rest: "30 Seconds",
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/false-grip/false-grip-row.png",
          title: "False Grip Row",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/40b7427b-9239-4708-95c8-1769b12f266e.gif?ClientID=sulu&Date=1708984458&Signature=c7e8cf03c3f4a95a67567acfa371315a9fb85e67",
          title: "False Grip Row",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004177925?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "False Grip Row",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "false-grip-pull-up-sometric-hold",
      title: "Pull Up Isometric Hold",
      sets: "3",
      reps: "30 seconds",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/false-grip/False+grip+pull+up+isometric+hold.jpg",
          title: "Pull Up Isometric Hold",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004166060?h=942e26d928&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Pull Up Isometric Hold",
          buttonTitle: "",
        },
      ],
    },

    {
      url: "false-grip-pull-up",
      title: "False Grip Pull Up",
      sets: "3",
      reps: "3-5",
      rest: "60 Seconds",
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/false-grip/false-grip-pull-up.png",
          title: "sample-image",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004181563?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "False Grip Pull Up",
          buttonTitle: "",
        },
      ],
    },
  ],
};

export const transitionData = {
  exercises: [
    {
      url: "",
      title: "Russian Press Up",
      sets: "3",
      reps: "3-5",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/russian-press-up-03.png",
          title: "Russian Press Up",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/russian-press-up-02.png",
          title: "Russian Press Up",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/russian-press-up-01.png",
          title: "Russian Press Up",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/f2c85121-d61b-4737-ad03-f78ab71c08d6.gif?ClientID=sulu&Date=1709458038&Signature=73c59f8954cef5f83e7432e24dcdd754c060774c",
          title: "Russian Press Up",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004228535?h=d7efad0f92&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Russian Press Up",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "",
      title: "Skin the Cat",
      sets: "3",
      reps: "3-5",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/skin-the-cat.png",
          title: "sample-image",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/97f329f3-a6fe-43d3-8f04-ce15878d2ea8.gif?ClientID=sulu&Date=1709458612&Signature=5736bfc4c09bad2af844a861b322959617e3807f",
          title: "sample-image",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004183902?h=75bd5e4024&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "placeholder",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "",
      title: "Box Assited Transitions",
      sets: "3",
      reps: "1",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/assited-transitions-01.png",
          title: "sample-image",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/assited-transitions-02.png",
          title: "sample-image",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/assited-transitions-03.png",
          title: "sample-image",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/assited-transitions-04.png",
          title: "sample-image",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/placeholder-image.jpg",
          title: "sample-image",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004231451?h=395644c968&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "placeholder",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "",
      title: "Negatives",
      sets: "3",
      reps: "1",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/negative+01.jpg",
          title: "negative 01",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/nagative+02.jpg",
          title: "negative 02",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/negative+03.jpg",
          title: "negative 03",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/negative+04.jpg",
          title: "negative 04",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/1d0757b7-2f7e-488c-90fc-14f412d43662.gif?ClientID=sulu&Date=1724963295&Signature=578637ee40867b28da836fc7dd89d5683e1a6278",
          title: "negative gif",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004177495?h=a851e0ae1b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Negatives",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "",
      title: "Transitions Unassisted",
      sets: "3",
      reps: "1-3",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/unassited-transitions-01.png",
          title: "sample-image",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/transition/unassited-transitions-02.png",
          title: "sample-image",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/563cca66-cca0-4453-984d-7ade3dc8687d.gif?ClientID=sulu&Date=1709459127&Signature=3b70c283ecdc5ec2bc23d7b1fdc07ece8b6ba5e7",
          title: "sample-image",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004236713?h=21a86481e9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Transitions Unassisted",
          buttonTitle: "",
        },
      ],
    },
    // {
    //   url: "",
    //   title: "German Hang",
    //   sets: "3",
    //   reps: "1-3",
    //   rest: false,
    //   description: <div></div>,
    //   images: [
    //     {
    //       url: "https://app-fitness.s3.eu-west-2.amazonaws.com/placeholder-image.jpg",
    //       title: "sample-image",
    //     },
    //     {
    //       url: "https://app-fitness.s3.eu-west-2.amazonaws.com/placeholder-image.jpg",
    //       title: "sample-image",
    //     },
    //     {
    //       url: "https://app-fitness.s3.eu-west-2.amazonaws.com/placeholder-image.jpg",
    //       title: "sample-image",
    //     },
    //   ],
    //   videoUrl: [
    //     {
    //       url: "https://player.vimeo.com/video/916892581?h=9ef289c90f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
    //       title: "placeholder",
    //       buttonTitle: "",
    //     },
    //   ],
    // },
  ],
};
export const strengthData = {
  exercises: [
    {
      url: "deep-dips-iso-holds",
      title: "Deep Dips Iso Holds",
      sets: "3",
      reps: "30 seconds",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/strength/++Deep+Dips+Iso+Holds.jpg",
          title: "Deep Dips Iso Holds",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004238394?h=b11aaec3ca&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Deep Dips Iso Holds",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "",
      title: "Deep Dips",
      sets: "3",
      reps: "3-5",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/strength/deep-dip-01.jpg",
          title: "deep-dip-01",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/strength/deep-dip-02.jpg",
          title: "deep-dip-02",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/a9e94bee-6bcb-49a5-b811-8a53041d971e.gif?ClientID=sulu&Date=1724963838&Signature=3119014c9a28b8c746fbd0f41fbf61a7c4a27d8a",
          title: "deep-dip-gif",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004186510?h=0e5e67c1cc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Deep Dips",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "",
      title: "Weighted False Grip Up Pulls",
      sets: "3",
      reps: "3",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/strength/Weighted+false+grip+pull+up.jpg",
          title: "Weighted False Grip Up Pulls",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/strength/Weighted+false+grip+pull+up-02.jpg",
          title: "Weighted False Grip Up Pulls-02",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/89faa18a-14b7-424f-882c-06faeac32293.gif?ClientID=sulu&Date=1724964029&Signature=8b4ed2c618268904a50e227e1d4e8e0f1603d6ea",
          title: "Weighted False Grip Up Pulls-gif",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004180844?h=c2ef680bf1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Weighted False Grip Up Pulls",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "front-support-hold",
      title: "Front Support Hold",
      sets: "3",
      reps: "3",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/strength/Front+Support+Hold.jpg",
          title: "Front Support Hold",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004188770?h=259c93e9ad&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Front Support Hold",
          buttonTitle: "",
        },
      ],
    },
  ],
};
export const shoulderConditioningData = {
  exercises: [
    {
      url: "butcher-block",
      title: "Butcher Block",
      sets: "",
      reps: "",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/strength/Butchers+block+stretch.jpg",
          title: "Butcher Block",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004242021?h=c6c37ae4c1&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Butcher Block",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "sleeps-stretch",
      title: "Sleeps Stretch",
      sets: "",
      reps: "",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/shoulder-conditioning/Sleeper+stretch+with+massage+ball-01.jpg",
          title: "Sleeps Stretch",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/shoulder-conditioning/Sleeper+stretch+with+massage+ball-02.jpg",
          title: "Sleeps Stretch",
        },
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/shoulder-conditioning/Sleeper+stretch+with+massage+ball-03.jpg",
          title: "Sleeps Stretch",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/9170cd63-d863-4446-b3cd-abf65dbb3c45.gif?ClientID=sulu&Date=1724965005&Signature=f44c766867943124d24285fd397b591ed1d4513a",
          title: "Sleeps Stretch gif 01",
        },
        {
          url: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/f3a84465-f4e5-4e97-8111-f7c4061fce9d.gif?ClientID=sulu&Date=1724965036&Signature=d38e5aadc17fa617344035b9caa877c6e03a8658",
          title: "Sleeps Stretch gif 02",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004243202?h=851cfe6634&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Sleeps Stretch",
          buttonTitle: "",
        },
      ],
    },
    {
      url: "childs-pose",
      title: "Childs Pose",
      sets: "",
      reps: "",
      rest: false,
      description: <div></div>,
      images: [
        {
          url: "https://app-fitness.s3.eu-west-2.amazonaws.com/muscle-ups/strength/childs-pose.jpg",
          title: "Childs Pose",
        },
      ],
      videoUrl: [
        {
          url: "https://player.vimeo.com/video/1004236608?h=3fcb6cf390&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
          title: "Childs Pose",
          buttonTitle: "",
        },
      ],
    },
  ],
};
